const interactiveTags = new Set([
	"A",
	"BUTTON",
	"INPUT",
	"OPTION",
	"SELECT",
	"TEXTAREA",
]);

type ClickTarget = {
	isContentEditable?: boolean;
	tagName?: string;
	closest?: (selector: string) => unknown;
};

const getClickTarget = (target: EventTarget | ClickTarget | null) => {
	if (target === null || typeof target !== "object") {
		return null;
	}
	return target as ClickTarget;
};

const getHasNoRowLink = (target: ClickTarget) => {
	return target.closest?.("[data-no-row-link]") != null;
};

const getIsInteractiveTag = (target: ClickTarget) => {
	if (target.tagName === undefined) {
		return false;
	}
	return interactiveTags.has(target.tagName.toUpperCase());
};

export const getShouldSkipCellClickAction = (
	target: EventTarget | ClickTarget | null,
) => {
	const clickTarget = getClickTarget(target);
	if (clickTarget === null) {
		return false;
	}
	if (getHasNoRowLink(clickTarget)) {
		return true;
	}
	if (clickTarget.isContentEditable === true) {
		return true;
	}
	return getIsInteractiveTag(clickTarget);
};
